import { FC } from 'react';
import { IonBadge } from '@ionic/react';
import styled from 'styled-components';
import { AllieBadgeProps } from './Badge.types';

const StyledBadge = styled(IonBadge)<AllieBadgeProps>`
  --background: ${(props) => `var(--allie-color-${props.allieColor || 'primary-90'})`};
  --color: var(--allie-color-light-main);
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: ${(props) => props.paddingInline || '8px'};
  --padding-end: ${(props) => props.paddingInline || '8px'};
  font-size: 12px;
  font-weight: 500;
  border-radius: 16px;
`;

export const AllieBadge: FC<AllieBadgeProps> = ({ children, ...props }) => (
  <StyledBadge {...props}>
    {children}
  </StyledBadge>
);
